import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, ViewChild, NgZone, OnChanges, AfterViewInit, ElementRef } from '@angular/core';
import { CommonModule, isPlatformBrowser, PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
// parent component
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take, catchError } from 'rxjs/operators';

// services
import { BookingService } from '../../services/booking.service';
import { MilesAndMore } from '../../services/miles-n-more.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { PriceService } from '../../services/price.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { AirportCopyService } from '../../../shared/services/app-airport-copy.service';
import { ValidationService } from '../../services/validation.service';
import { AppLoaderService } from '../../../shared/services/app-loader.service';
import { LoginService } from '../../../shared/services/login.service';
import { EventsService } from '../../services/events.service';
import { SharedService } from '../../../shared/services/shared-service.service';
import { AppStateService } from '../../../shared/services/app-state.service';
import { BagItemsService } from '../../../shared/services/bagItems.service';
import { ExternalScriptsService } from '../../../shared/services/external-scripts.service';
import { ApplePayService } from '../../../booking/services/apple-pay.service';
// models
import { AppState } from '../../models/app-state.interface';
import { ModalData } from '../../../shared/models/modal.interface';
import { LoadingStatus } from '../../../shared/models/app-loader.interface';
import { CardData } from '../../models/card-data.interface';
import { BookingInitState } from '../../models/booking-reducer.interface';
import { MilesRangeRequest } from '../../models/miles-and-more';
import { UserInitState } from '../../../shared/models/user-reducer.interface';
import { PaymentRequest } from '../../models/payment-request.interface';

import { bookingKeyStart, bookingKey } from '../../shared/variables';

import moment from 'moment';
import { BillingAddress } from 'app/booking/models/payment.interface';
import { COUNTRY_CODES, MILES_LOGIN_URL } from '../../../shared/globals';
import { FormsModule } from '@angular/forms';
import { MilesAndMorePayComponent } from 'app/booking/components/payment/miles-and-more-pay/miles-and-more-pay.component';
import { ApplePayComponent } from 'app/booking/components/payment/apple-pay/apple-pay.component';
import { BookerFormComponent } from 'app/booking/components/payment/booker-form/booker-form.component';
import { StandardPaymentComponent } from 'app/booking/components/payment/standard-payment/standard-payment.component';
import { RecurringPaymentComponent } from 'app/booking/components/payment/recurring-payment/recurring-payment.component';
import { PriceBreakdownComponent } from '@shared/components/price-breakdown/price-breakdown.component';
import { PromoComponent } from '@shared/components/promo/promo.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { hasCustomsAgreement, removePromo, saveSelectedTimeslotDateTime, updateBookingAmendSection, updateCustomerHasMarketingEnrolment, updateD2DService } from 'app/booking/reducers/booking.actions';
import { amendPaymentConfirmed } from 'app/booking/reducers/price.reducer';
import { cardType, paymentType, paymentWithSavedCard, promoDetails, saveFormData, updateCurrentBookingProduct } from 'app/booking/reducers/d2d-booking.reducer';
import { UPDATE_NEW_USER, UPDATE_USER } from '@shared/reducers/user.reducer';
import { refreshBookingObject } from 'app/booking/reducers/current-booking.reducer';
import { SharedDirectiveModule } from '@shared/shared-directive.module';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';

declare var ga: any;
declare var adyen: any;
declare var ThreedDS2Utils: any;
declare var fbq: any;
declare var exponea: any;
declare var ApplePaySession: any;
declare var google: any;

let bookingPriceData = '';
let currencyCode = 'GBP';
let countryCode = 'GB'
const cardTypes = {
  '2': 'Mastercard',
  '5': 'Mastercard',
  '3': 'American Express',
  '4': 'Visa',
  '6': 'Discover',
}

@Component({
  selector: 'app-step-payment',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MilesAndMorePayComponent,
    ApplePayComponent,
    BookerFormComponent,
    StandardPaymentComponent,
    RecurringPaymentComponent,
    PriceBreakdownComponent,
    PromoComponent,
    GooglePayButtonModule,
    SharedDirectiveModule,
    LanguageSelectorComponent
  ],
  templateUrl: './step-payment.component.html',
  styleUrls: ['./step-payment.component.scss'],
  providers: [DataStorageService, ValidationService]
})
export class StepPaymentComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  @ViewChild('bookerForm') bookerForm;
  @ViewChild('standardPaymentForm') standardPaymentForm;
  @ViewChild('recurringPaymentForm') recurringPaymentForm;
  @ViewChild('termsForm') termsForm;
  @ViewChild('termsFormExpresscheckout') termsFormExpresscheckout;
  @ViewChild('threeDS2Form') threeDS2Form;
  @ViewChild('threeDs1Form') threeDs1Form;
  @ViewChild('formBillingAddress') formBillingAddress;
  @ViewChild('applePay') applePayForm;

  public applePaySdk: Promise<any>;
  public paymentOptionsAvailable = {
    card: true,
    gpay: true,
    apple: false
  }; // 2 for apple pay testing

  private _bookingInitSubscription: Subscription;
  private _amendBookingCallSub: Subscription;
  private _userSubscription: Subscription;
  private _priceSubscription: Subscription;
  private _bookingStateSubscription: Subscription;
  private _validatePhoneNumberSubscription: Subscription;
  private _cardDeletedSubscription: Subscription;
  private _updatedUserSubscription: Subscription;
  private _userLoggedInSubscription: Subscription;
  private _userLoggedOutSubscription: Subscription;
  private _loaderSubscription: Subscription;
  private _cardDeletedRequestSentSubscription: Subscription;
  private _threeDS2Subscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _d2dBookingSubscription: Subscription;
  private _upsellBookingSubscription: Subscription;
  private _applePaymentSubmitSubscription: Subscription;
  private _milesStateSubscription$: Subscription;
  private _priceStatusSubscription$: Subscription;
  private _milesSubscription: Subscription;
  private _flybackReducerSubscription: Subscription;

  private _bookingCarrier;
  private _bookingJourneyReference;
  private _promoDiscount;
  private _promoActive: Boolean = false;
  private _gaPromoEvent;
  private _useSavedCard = false;
  private _saveCard = false;
  private _recurringReference = '';
  private _savedCardDetails = null;
  private _dt;
  private _cardData: CardData = {
    number: '',
    cvc: '',
    generationtime: '',
    expiryMonth: '',
    expiryYear: '',
    holderName: ''
  };
  private _encryptedData;
  private _keyStart: string = environment.bookingKeyStart;
  private _key: string = this._keyStart + environment.bookingKey;
  private _options: Object = {};
  private _maskedNumber = '';
  private _googlePayMaskNumber = '';
  private _googlePayData: any;
  private _applePayData: any = null;
  private _googlePayToken = '';
  private _applePayToken = '';
  private _transactionType = 'New';
  private _businessTransactionType = 'NewBusiness';
  private _bookingCompleteFlag = false;
  private _sendGAPageview = true;
  private _latestFlight;
  private _firstLoad = true;
  private _priceHistoryMinor = null;
  private _threedsContainer;
  private _threedsIframe;
  private paymentEventFired = false;
  private milesUserDataLoaded = true;
  private _customerLocationCoord = null;

  public flightDirection;
  public countryCodes = COUNTRY_CODES.all;
  public bookingInit: Boolean = false;
  public pricingInit: Boolean = false;
  public copyLoaded: Boolean = false;
  public appCopy;
  public appAirportCopy;
  public currentBooking;
  public bookingState: BookingInitState;
  public user: UserInitState;
  public userDetails;
  public disableBook: Boolean = false;
  public phoneNumberValid = true;
  public userRole;
  public eligibleForInvoice: Boolean = false;
  public showInvoice: Boolean = false;
  public payByInvoice: Boolean = false;
  public showOverridePayment = false;
  public overridePayment = false;
  public price;
  public oldprice: any;
  public oldPriceMessage: any;
  public priceValidation: any;
  public isVisible: boolean = false;
  public virtualBags = null;
  public userHasCards = false;
  public userCards = null;
  public selectedCard;
  public selectedCardItem;
  public bookingAmendSection;
  public bookingType;
  public showAmendLoader = false;
  public hasPriceDifference = false;
  public priceDifferenceAmout = 0;
  public bookingProduct;
  public togglePromo = false;
  public priceHistoryMajor = null;
  public flightCodeNumber: any;
  public paymenttype: any = 2; // 0 = google Pay, 1 = Apple Pay, 2 = Card payment
  public ccdCheckbox: boolean;
  public showLoader: Boolean = false;
  private _stateSubscription: Subscription;
  public billingAddress: BillingAddress = null;
  public isCustomerSupport = false;
  public billingAddressValid = true;
  public showThreeDS2Form = true;
  public threeDS2Data = {
    request: '',
    postURL: '',
    originURL: '',
    type: ''
  };
  public threeDs1Data = {
    md: '',
    pReq: '',
    termUrl: '',
    issueUrl: '',
    notificationUrl: ''
  }
  public threeDsPaymentType = '';
  public showChallengeShopper = false;
  public selectedLanguage = '';
  public selectedLanguageCode = 'en';
  public premiumSurcharge;
  public customsInspection = false;
  public emiratesSkywards = false;
  public upsellFormData = { set: false, data: null };
  public totalD2dPrice: any = 0;
  public isD2dService = false;
  public canDoMilesLogin = false;
  public milesLoaded: LoadingStatus = 'idle';
  public callbackURL;
  public milesLoginUrl = MILES_LOGIN_URL;
  public milesReducer = null;
  public bookingAmendType = 'none';
  public env = environment.envName;
  public cutOffTimeWindowDate: string;
  public cutOffTimeWindowTime: string;
  public bookingAirportName: string;
  public bookingAirlineName: string;
  public paymentData: any;

  constructor(
    private _appStore: Store<AppState>,
    private _bookingService: BookingService,
    private _dataStorageService: DataStorageService,
    private _pricingService: PriceService,
    private _copyService: CopyService,
    private _airportCopyService: AirportCopyService,
    private _validationService: ValidationService,
    private _errorService: ErrorHandler,
    private _appLoaderService: AppLoaderService,
    private _loginService: LoginService,
    private _eventsService: EventsService,
    private _bagItemsService: BagItemsService,
    private _zone: NgZone,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _sharedService: SharedService,
    private _appStateService: AppStateService,
    private _externalScriptsService: ExternalScriptsService,
    private _applePayService: ApplePayService,
    private _http: HttpClient,
    private _milesAndMoreService: MilesAndMore,
    private _platformLocation: PlatformLocation,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.callbackURL = this._platformLocation.href.split('?')[0]

  }

  ngOnInit() {
    const state = this.getState(this._appStore);
    const flybackReducer = state.flybackReducer
    const flyBackRedirect = flybackReducer.flyBackRedirect;
    if(flyBackRedirect) {
      this._appLoaderService.hideLoader();
    }





    if(this._activatedRoute.snapshot.queryParams['d2d'] === 'falseD2D') {
      this._appStore.dispatch(updateD2DService({ payload: false }));
      this._dataStorageService.saveData()
    }

    this.bookingAmendType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendType;
    this.selectedLanguageCode = this.getState(this._appStore).copyReducer.languageCode;
    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data
        if (res.currentBookingLoaded && res.copyLoaded && res.userLoaded && !this.paymentEventFired) {
          this.paymentEventFired = true;
          const state = this.getState(this._appStore);
          exponea.track('oldfunnel_payment', {
            logged_in: state.userReducer.userDetails.userLoggedIn,
            email: state.userReducer.userDetails.userEmail
          });

          setTimeout(() => {
            this._dataStorageService.saveData();
          }, 0);

          let collectionDateTimeUTC =  moment(state.currentBookingReducer.currentBooking.bookingJourney[0].collectionDateTimeUTC);
          if (this.getState(this._appStore).bookingReducer.bookingDetails.bookingProduct === 'ccd') {
            const requestedDateTime = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightInfo.requestedDateTime;
            collectionDateTimeUTC = moment(requestedDateTime);
          }
          const cutOffTimeWindow = state.timeslotReducer.cutOffTimeWindow; // minutes
          const diff = collectionDateTimeUTC.subtract(cutOffTimeWindow, "minutes").toDate();

          this.cutOffTimeWindowDate = moment(diff).format('MMMM DD');
          this.cutOffTimeWindowTime = moment(diff).format('hh:mm A');

        }

        if (res.currentBookingLoaded && res.copyLoaded && res.airportCopyLoaded && this._firstLoad) {
          const bookingType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingType;
          const bookingAmendType = this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendType;
          const bookingAmendSection = this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendSection;
          const amendUserCards = this.getState(this._appStore).userReducer.userDetails.amendUserCards;

          this._firstLoad = false;
          this.bookingInit = res.currentBookingLoaded;
          this.copyLoaded = res.copyLoaded;

          if (bookingType === 'amend' && bookingAmendType === 'refund') {
            this.paymentOptionsAvailable.gpay = false;
            this.paymentOptionsAvailable.apple = false;
          }

          // if user has redirected back from miles and more with transaction id
          // and status we need to wait for user to load
          if (bookingType === 'amend' && bookingAmendSection !== 'booker') {
            this._appStore.dispatch(updateBookingAmendSection({ payload: 'payment' }));
          }
          const qParams = this._activatedRoute.snapshot.queryParams;
          if (bookingType === 'amend' && ((qParams['id'] && qParams['status']) || qParams['code'])) {
            this._firstLoad = true;
            this.milesUserDataLoaded = false;
            if (res.userLoaded && res.priceLoaded) {
              this.milesUserDataLoaded = true;
              this._firstLoad = false;
            }
          }
          // if amend and user doesn't have amend cards, cancel amend
          if (this.milesUserDataLoaded) {
            const state = this.getState(this._appStore).userReducer.userDetails;
            if (bookingType === 'amend' && !amendUserCards) {
              this.currentBooking = this.getState(this._appStore).currentBookingReducer.currentBooking;

              const errorData = {
                text: 'There seems to be a problem fetching your payment details. Please try again.',
                sticky: true
              };
              this._errorService.handleCustomError(errorData);

              this.cancelAmend();
            } else {
              this.setDataSubscriptions();

              if (isPlatformBrowser(this.platformId)) {
                this.getAirportCopy();
                this.getCopy();
              }

              this._userLanguageSubscription = this._appStore.select('copyReducer')
                .subscribe((res: any) => {
                  this.selectedLanguage = res.language
                })
            }
          }
        } else {
          return;
        }
      });
    // // check if amend paymend refunded or taken
    this._amendBookingCallSub = this._appStore.select('priceReducer')
      .subscribe((res) => {
        if (res.amendPaymentConfirmed) {
          this._appStore.dispatch(amendPaymentConfirmed({ confirmed: false }));
          this.handlePaymentAmend();
        }
      })
    // set user values on login and logout
    this._userLoggedInSubscription = this._loginService.userSubject$.subscribe(res => {
      this.setUserValues(this.getState(this._appStore).userReducer);
    });
    this._userLoggedOutSubscription = this._loginService.userLoggedOut$.subscribe(res => {
      this.setUserValues(this.getState(this._appStore).userReducer);
    });

    this._loaderSubscription = this._appLoaderService.loaderState$
      .subscribe(res => {
        if (res.show === false) {
          this.disableBook = false;
        }
      });

    this._applePaymentSubmitSubscription = this._applePayService.onPaymentSubmit$
    .subscribe(res => {
      if (res) {
        this.handleApplePayComplete();
      }
    });

    this.initializeApplePay();
  }

  initializeApplePay () {
    if (isPlatformBrowser(this.platformId)) {
      this.applePaySdk = new Promise((resolve) => {
        const options = {
          crossorigin: true,
          id: "apple-pay-js",
          src: "https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js",
        };

        this._externalScriptsService.loadScript(options, () => {
          // console.log("Apple pay sdk loaded");

          if (typeof ApplePaySession === "undefined") {
            this.hideApplePayButton();
          } else {
            this.displayApplePayButton();
          }
        });
        resolve(true);
      });
    }
  }

  displayApplePayButton() {
    // console.log('Apple pay is available');
    this.paymentOptionsAvailable.apple = true;
  }

  hideApplePayButton() {
    // console.log('Apple pay is not available');
    this.paymentOptionsAvailable.apple = false;
  }


  getPaymentData() {
    const state = this.getState(this._appStore);
    let isD2dService = state.bookingReducer.bookingDetails.isD2dService;
    let total_price = isD2dService
      ? this.getD2dDiscountPrice()
      : this.price.pricingResponse[0].pricingBreakdown.discountedTotalPriceMajor.toFixed(2); // new/failed payment
    if ( (this.bookingState.bookingDetails.bookingAmendType === "refund" && this.bookingType === "amend")
        ||(this.bookingState.bookingDetails.bookingAmendType === "payment" && this.bookingType === "amend")) {
      total_price = this.price.priceHistory.majorAmount; // for amend flow
    }

    bookingPriceData = total_price.toString();
    this.paymentRequest.transactionInfo.totalPrice = bookingPriceData;
  }

  googlePaymentData(paymentData) {
    this._bookingService.setGooglePaymentToken(paymentData);
    const state = this.getState(this._appStore);
    let isD2dService = state.bookingReducer.bookingDetails.isD2dService;
    let total_price = isD2dService
      ? this.getD2dDiscountPrice()
      : this.price.pricingResponse[0].pricingBreakdown.discountedTotalPriceMajor.toFixed(2); // new/failed payment
    if ( (this.bookingState.bookingDetails.bookingAmendType === "refund" && this.bookingType === "amend")
        ||(this.bookingState.bookingDetails.bookingAmendType === "payment" && this.bookingType === "amend")) {
      total_price = this.price.priceHistory.majorAmount; // for amend flow
    }
    this._bookingService.setOldPriceService(total_price.toString())

  }
  ngOnChanges(): void {

    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'price'**************/
    //Write your code here
    // console.log(this.price, 'ngonchanges');
    this.getPaymentData();
    this.oldprice = this.price;

  }

  paymentRequest: google.payments.api.PaymentDataRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: 'CARD',
        parameters: {
          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
          allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD']
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'adyen',
            gatewayMerchantId: "PortrLtd",

          }
        }
      }
    ],
    merchantInfo: {
      merchantId: environment.gPayMerchantId,
      merchantName: environment.gPayMerchantName
    },
    emailRequired: true,
    shippingAddressRequired: true,
    shippingAddressParameters: {
      phoneNumberRequired: true,
      allowedCountryCodes: []
    },
    transactionInfo: {
      totalPriceStatus: 'FINAL',
      totalPriceLabel: 'Total',
      totalPrice: bookingPriceData,
      currencyCode: currencyCode,
      countryCode: countryCode
    },
    callbackIntents: ['PAYMENT_AUTHORIZATION'],
  };

  onLoadPaymentData = (
    event: Event
  ): void => {
    // console.log('pay btn');

    const eventDetail = event as CustomEvent<google.payments.api.PaymentData>;
    this.googlePaymentData(eventDetail.detail);
  }



  onPaymentAuthorizedData: google.payments.api.PaymentAuthorizedHandler = (
    paymentData
  ) => {

    if (paymentData != null) {
      this.paymentData = paymentData;
      // this.sendBookerToRequest(this.bookerForm.bookerData);
      // if booking type is amend
      if (paymentData.paymentMethodData.tokenizationData.token) {
        this._bookingService.setGooglePaymentToken(paymentData);
      }
      this.recievePaymentType(0);
      if (this.bookingType === 'amend') {
        this.handlePaymentAmend();
      } else {
        this.handlePaymentOptionSubmit();
        // this.handlePaymentSubmit();
      }
    } else {
      this.showAmendLoader = false;
    }

    return {
      transactionState: 'SUCCESS'
    };
  }

  onPressButton = (event: Event): void => {
    const currentAppState = this.getState(this._appStore);
    currencyCode = currentAppState.timeslotReducer.currency.code;
    this.paymentRequest.transactionInfo.currencyCode = currencyCode;

    let total_price = this.isD2dService
      ? this.getD2dDiscountPrice()
      : this.price.pricingResponse[0].pricingBreakdown.discountedTotalPriceMajor.toFixed(2); // new/failed payment
    if ( (this.bookingState.bookingDetails.bookingAmendType === "refund" && this.bookingType === "amend")
        ||(this.bookingState.bookingDetails.bookingAmendType === "payment" && this.bookingType === "amend")) {
      total_price = this.price.priceHistory.majorAmount; // for amend flow
    }
    this._bookingService.setOldPriceService(total_price.toString())
    // // console.log(this.isPaymentFormValidate,'OpenSheet');
    const bookerFormHasError = typeof this.bookerForm.bookerData !== 'undefined';
    const formHasStandardForm = typeof this.standardPaymentForm !== 'undefined';
    const formHasRecurringForm = typeof this.recurringPaymentForm !== 'undefined';

    const termsForm = typeof this.termsFormExpresscheckout !== 'undefined';
    // if (formHasStandardForm && !this.standardPaymentForm.form.valid) {
    //   this._validationService.markFormDirty(this.standardPaymentForm.form);

    // }
    // if (formHasRecurringForm && !this.recurringPaymentForm.form.valid) {
    //   this._validationService.markFormDirty(this.recurringPaymentForm.form);

    // }
    if (termsForm && !this.termsFormExpresscheckout.form.valid) {
      this._validationService.markFormDirty(this.termsFormExpresscheckout.form);
    }
    if (this.bookingType !== 'amend') {
      if (!this.termsFormExpresscheckout.form.valid) {
        event.preventDefault();
      }
    }


  }


  onError = (event: ErrorEvent): void => {
    console.error('error', event.error);
  }

  recievePaymentType(value: number) {
    this.paymenttype = value;
    this._appStore.dispatch(paymentType({ payload: value }));
  }

  async setDataSubscriptions() {
    this.setCurrentStoreVars();
    // if hubdrop booking we need to generate new booking reference
    // to handle Miles and More booking referenc
    if(this.bookingType !== 'amend') {
      await this._bookingService.getBookingReferenceForRequest();
    }
    const state = this.getState(this._appStore);

    // threeDSIframe event
    window.addEventListener('message', (e) => this.handleThreeDSIframeEvent(e));

    // set init user values once on load
    this._userSubscription = this._appStore.select('userReducer')
      .pipe(take(1))
      .subscribe((user: UserInitState) => { this.setUserValues(user); });

    this._milesStateSubscription$ = this._milesAndMoreService.milesLoading$
      .subscribe(res => {
        this.milesLoaded = res;
      });

    this._priceStatusSubscription$ = this._pricingService.priceUpdating$
      .subscribe(isUpdating => {
        this.showLoader = isUpdating
      });

    this._priceSubscription = this._appStore.select('priceReducer')
      .subscribe((price: any) => {
        this._zone.run(() => {
          this.oldprice = this.price;
          this.price = price.price;
          if (Object.keys(this.price).length > 0) {
            // show error if user hasn't logged in
            if (this.price.validationErrorMessages !== null) {
              if (this.price.validationErrorMessages && this.price.validationErrorMessages[0].code === 702) {
                const errorData = {
                  text: this.price.validationErrorMessages[0].reasons[0],
                  sticky: false
                };
                this._errorService.handleCustomError(errorData);
                this._appStore.dispatch(removePromo({ payload: [] }));
              }
            }

            this._promoDiscount = this.price.discountAppliedMinor;

            if (this.price.promoCodesApplied !== null) {
              this._promoActive = true;
            } else {
              this._promoActive = false;
              this._gaPromoEvent = true;
            }

            if (this.price.promoCodesApplied !== null && this._promoActive && this._gaPromoEvent) {
              this._gaPromoEvent = false;
              this.disableBook = false;
              ga('send', 'event', 'Promo Code Applied', this.price.promoCodesApplied[0]);
            }

            if (typeof this.price.priceHistory !== 'undefined') {
              this.hasPriceDifference = true;
              this.priceDifferenceAmout = this.price.priceHistory.majorPriceDifference;
              this._priceHistoryMinor = this.price.priceHistory.minorAmount;
              this.priceHistoryMajor = this.price.priceHistory.majorAmount;
              //for googlePay
              window['angularGooglePayComponentReference'] = {
                component: this, zone: this._zone,
                loadGooglePaymentFunction: (paymentData) => this.googlePaymentData(paymentData),
              };
              this.getPaymentData();
            }

            this.canDoMilesLogin = this.price.enableMilesLogin;
            const code = this._activatedRoute.snapshot.queryParams['code'];
            if (code && !this.pricingInit) {
              let totalPrice = this.isD2dService ? this.getD2dDiscountPrice() * 100 : this.price.totalPrice.minorAmount;
              if (this.bookingType === 'amend') {
                totalPrice = this._priceHistoryMinor;
              }
              const request: MilesRangeRequest = {
                authCode: code,
                redirectUri: this.callbackURL,
                totalPrice: totalPrice,
                currency: price.price.totalPrice.currencyCode
              }
              this._milesAndMoreService.getMilesRange(request);
              this._router.navigate([], { replaceUrl: true, queryParams: {}, relativeTo: this._activatedRoute });
            }

            if (this.price.totalPrice.majorAmount === 0) {
              this.paymentOptionsAvailable.gpay = false;
              this.paymentOptionsAvailable.apple = false;
              this.paymenttype = 1;
            } else {
              this.paymentOptionsAvailable.gpay = true;
              if (typeof ApplePaySession !== "undefined") {
                this.paymentOptionsAvailable.apple = true;
              }
            }
            this.pricingInit = true;
            this.getD2dDiscountPrice();
          }
        });
      });

    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe((bookingState: any) => {

        // if bags have been changed, get new prices
        if (this.virtualBags !== null && this.virtualBags !== bookingState.bookingDetails.virtualBagCount) {
          this.virtualBags = bookingState.bookingDetails.virtualBagCount;
          this._pricingService.updatePriceBags(this.virtualBags);
        } else {
          this.virtualBags = bookingState.bookingDetails.virtualBagCount;
        }
        this.premiumSurcharge = bookingState.bookingDetails.premiumSurcharge;
        this.isD2dService = bookingState.bookingDetails.isD2dService;
        if (state.d2dReducer.promoCode.length > 0) {
          this.togglePromo = true;
        }
      });

    this._milesSubscription = this._appStore.select('milesAndMoreReducer')
      .subscribe(miles => {
        this.milesReducer = miles;
      });

    this._validatePhoneNumberSubscription = this._bookingService.validPhoneNumberSubject$
      .subscribe(valid => {
        if (!valid) {
          this.bookerForm.form.controls['contactPhone'].setErrors({ 'incorrect': true });
          this.phoneNumberValid = false;
        } else {
          this.bookerForm.form.controls['contactPhone'].setErrors(null);
          this.phoneNumberValid = true;
        }
      });

    this._cardDeletedRequestSentSubscription = this._pricingService.cardRemovedRequestSent$
      .subscribe(res => {
        if (res) {
          this.disableBook = true;
        }
      });

    this._cardDeletedSubscription = this._pricingService.cardRemovedSubject$
      .subscribe(value => {
        if (value) {
          this._loginService.getUserByID(this.userDetails.currentUser.userId, this.userDetails.userToken, 1);
        } else {
          this.disableBook = false;
        }
      });

    this._updatedUserSubscription = this._loginService.userIDSubject$
      .subscribe(res => {
        this._appStore.dispatch(UPDATE_USER({ currentUser: res[0] }));
        const newUserData = this.getState(this._appStore).userReducer;
        this.setUserValues(newUserData);
        this.disableBook = false;
      });

    this._threeDS2Subscription = this._appStore.select('threeDS2Reducer')
      .subscribe(res => {
        if (res.data.request !== '') {
          this.threeDS2Data = res.data;

          if (this.threeDS2Data.type === 'identify') {

            this._threedsContainer = document.getElementById('threedsContainer');
            const IFRAME_NAME = 'threeDSMethodIframe';
            this._threedsIframe = ThreedDS2Utils.createIframe(this._threedsContainer, IFRAME_NAME, '100%', '100%');
            const form = ThreedDS2Utils.createForm('threedsMethodForm', this.threeDS2Data.postURL, IFRAME_NAME, 'threeDSMethodData', this.threeDS2Data.request);

            this._threedsContainer.appendChild(form);
            setTimeout(() => {
              this._threedsContainer.removeChild(form);
            }, 1000);

            form.submit();
          } else if (this.threeDS2Data.type === 'challenge') {
            const IFRAME_NAME = 'threeDSChallengeIframe';
            const iframeSizesArr = ThreedDS2Utils.config.getChallengeWindowSize('05');

            this._threedsContainer = document.getElementById('threedsContainer');
            this._threedsIframe = ThreedDS2Utils.createIframe(this._threedsContainer, IFRAME_NAME, iframeSizesArr[0], iframeSizesArr[1]);
            const form = ThreedDS2Utils.createForm('cReqForm', this.threeDS2Data.postURL, IFRAME_NAME, 'creq', this.threeDS2Data.request);

            this._threedsContainer.appendChild(form);

            this.showChallengeShopper = true;
            this._appLoaderService.hideLoader();

            setTimeout(() => {
              this._threedsContainer.removeChild(form);
            }, 1000);

            form.submit();
          }
        } else if (res.data.paymentSessionId && res.data.paymentSessionId !== '') {

          this.threeDs1Data.md = res.data.paymentSessionId;
          this.threeDs1Data.pReq = res.data.paymentRequest;
          this.threeDs1Data.issueUrl = res.data.issueUrl;
          this.threeDs1Data.termUrl = res.data.termUrl;
          this.threeDs1Data.notificationUrl = res.data.notificationUrl;

          const IFRAME_NAME = 'threeDSRedirectIframe';
          const iframeSizesArr = ThreedDS2Utils.config.getChallengeWindowSize('05');

          this._threedsContainer = document.getElementById('threedsContainer');
          this._threedsIframe = ThreedDS2Utils.createIframe(this._threedsContainer, IFRAME_NAME, iframeSizesArr[0], iframeSizesArr[1]);
          const form = ThreedDS2Utils.createFormForRedirectShopper('RedirectShopperForm', this.threeDs1Data.issueUrl, IFRAME_NAME, 'PaReq', this.threeDs1Data.pReq, 'MD', this.threeDs1Data.md, "TermUrl", this.threeDs1Data.termUrl);
          this._threedsContainer.appendChild(form);

          this.showChallengeShopper = true;
          this._appLoaderService.hideLoader();

          setTimeout(() => {
            this._threedsContainer.removeChild(form);
          }, 1000);

          form.submit();
        }
      });

    let flightReducer;

    this._stateSubscription = this._appStore.select('flightReducer').subscribe(res => {
      flightReducer = res;
      this.ccdCheckbox = res.flightDetails.flightProducts.ccd;
    });
    const flightData = flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
    if (flightData.airlineCode === 'AF' && flightData.departureAirport.airportCode === 'GVA' && flightReducer.flightDetails.flightProducts.abc) {
      this.customsInspection = true;
    }
    this._appStore.dispatch(updateCurrentBookingProduct({ payload: this.bookingProduct }));
    this._upsellBookingSubscription = this._bookingService.upsellBookingAdded$
      .subscribe(res => {
        const state = this.getState(this._appStore);
        if (res) {
          if (this.bookingProduct === 'abc') {
            // this._eventsService.generatePaths('ccd');
            // this._bookingService.updateBookingInstance(state.d2dReducer.inboundBooking.currentBookingReducer);
            // this._router.navigate(['/redirectingTo'],
            //   { queryParams: { redirectToPath: '/abc/payment', bookingProduct: 'abc' } });

            // setTimeout(() => {
            this._router.navigate(['/ccd/payment']);
            this._appStateService.setBookingStores(state.d2dReducer.inboundBooking);
            // }, 2000);

            // setTimeout(() => {
            //   this.handlePaymentSubmit();
            // }, 2500);

          } else {
            // this._eventsService.generatePaths('abc');
            // this._bookingService.updateBookingInstance(state.d2dReducer.outboundBooking.currentBookingReducer);
            // this._router.navigate(['/redirectingTo'],
            //   { queryParams: { redirectToPath: '/ccd/payment', bookingProduct: 'ccd' } });
            // setTimeout(() => {
            this._router.navigate(['/abc/payment']);
            this._appStateService.setBookingStores(state.d2dReducer.outboundBooking);
            // }, 2000);
          }
        }
      });

      if (flightData.airlineCode === 'EK') {
        this.emiratesSkywards = true;
      }

    const bagParams = this._activatedRoute.snapshot.queryParams['bags'];
    if (bagParams && !bagParams.serviceToRemove) {
      const bagItems = JSON.parse(bagParams);
      const totalBags = this._bagItemsService.getTotalItems(bagItems);
      this._appStateService.setBagItems({ ...bagItems });
      this._appStateService.setVirtualBags(totalBags);

      this._bookingService.updateBagItems({ ...bagItems });
      this._bookingService.updateVirtualBags(totalBags);

      this._router.navigate([], { replaceUrl: true, queryParams: {}, relativeTo: this._activatedRoute });
    }

    // if d2d booking and is primary booking set form data
    if (state.bookingReducer.bookingDetails.isD2dService && state.d2dReducer.addBookingCount === 1) {
      this.upsellFormData = { set: true, data: state.d2dReducer.formData };

      //
      this._appStore.dispatch(hasCustomsAgreement({payload: true }));
      ga('send', 'event', 'Vanilla', 'Pay - Consent', 'Checked');
    }

    this._appStore.dispatch(saveSelectedTimeslotDateTime({ payload: this.getState(this._appStore).timeslotReducer.selectedTimeslotDateTime }));

    if (this._sendGAPageview) {
      this._sendGAPageview = false;
      if (this.currentBooking.bookingJourney[0].addOnProductType.length > 0) {
        if (this.bookingType !== 'amend') {
          ga('set', 'page', '/abc/payment/' + this._latestFlight);
          ga('send', 'pageview');
        } else if (this.bookingType === 'amend') {
          ga('set', 'page', '/a/abc/payment');
          ga('send', 'pageview');
        }
      } else {
        if (this.bookingType !== 'amend') {
          ga('set', 'page', '/sds/payment');
          ga('send', 'pageview');
        } else if (this.bookingType === 'amend') {
          ga('set', 'page', '/a/sds/payment');
          ga('send', 'pageview');
        }
      }
    }

  }

  getD2dDiscountPrice() {
    const {totalD2dPrice } = this._bookingService.getD2dDiscountPrice(this.price);
    this.totalD2dPrice = totalD2dPrice;
    return this.totalD2dPrice;
  }

  setUserValues(u) {
    this.user = u;
    this.userDetails = this.user.userDetails;
    this.eligibleForInvoice = this.userDetails.currentUser.eligibleForInvoice;
    this.showInvoice = this.userDetails.userRole !== 'GUEST' && this.eligibleForInvoice && this.bookingType !== 'amend';
    this.showOverridePayment = this.bookingType === 'amend' && (this.userDetails.userRole === 'SUPERADMIN' || this.userDetails.userRole === 'ADMIN' || this.userDetails.userRole === 'CONCIERGE' || this.userDetails.userRole === 'EXTERNALAGENT');
    this.isCustomerSupport = this.getState(this._appStore).flightFinderReducer.csMotoFromUrl || this.userDetails.userPermissions.showAdminFeatures;

    // reset billing valid
    this.billingAddressValid = true;

    if (this.bookingType !== 'amend') {
      // if not amend - get cards from currentUser obj
      if (this.user.userDetails.currentUser.cardDetails === null
        || typeof this.user.userDetails.currentUser.cardDetails === 'undefined') {
        this.userHasCards = false;
      } else {
        this.userHasCards = true;
        this.userCards = this.userDetails.currentUser.cardDetails;
        this.selectedCard = 'card0';
        this.selectedCardItem = this.userDetails.currentUser.cardDetails[0].recurringDetailReference;
      }
    } else if (this.bookingType === 'amend') {
      // check user cards sent in getCompleteBookingRequest (amendUserCards)
      // saved in user reducer
      if (this.user.userDetails.amendUserCards === null || typeof this.user.userDetails.amendUserCards === 'undefined' || this.user.userDetails.amendUserCards.length === 0) {
        this.userHasCards = false;
      } else {
        this.userHasCards = true;
        this.userCards = this.userDetails.amendUserCards;
        this.selectedCard = 'card0';
        this.selectedCardItem = this.userDetails.amendUserCards[0].recurringDetailReference;
      }
    }

  }

  setCurrentStoreVars() {
    const currentAppState = this.getState(this._appStore);
    // current booking store vars
    this.currentBooking = currentAppState.currentBookingReducer.currentBooking;
    // booking store vars
    this.bookingState = currentAppState.bookingReducer;
    this.bookingType = currentAppState.bookingReducer.bookingDetails.bookingType;
    this.bookingProduct = currentAppState.bookingReducer.bookingDetails.bookingProduct;
    this.flightDirection = currentAppState.bookingReducer.bookingDetails.journeyLegDetails[0].journeyDirection;
    this._bookingJourneyReference = currentAppState.bookingReducer.bookingDetails.bookingJourneyReference;
    this._bookingCarrier = this.bookingState.bookingDetails.carrier.airlineCode;
    this.bookingAmendSection = this.bookingState.bookingDetails.bookingAmendSection;
    this._latestFlight = currentAppState.flightReducer.flightDetails.flightResponse.flightStatusDetails[0].airlineCode;
    const flightDetails = currentAppState.flightReducer.flightDetails.flightResponse.flightStatusDetails;
    this.bookingAirportName = this.flightDirection === 1 ? flightDetails[0].departureAirport.airportName : flightDetails[flightDetails.length - 1].arrivalAirport.airportName;
    this.bookingAirlineName = flightDetails[0].airlineName
    // if collection/delivery address is residential, prefill billing address
    if (this.flightDirection === 1 && this.currentBooking.bookingJourney[0].collectionLocation.type === 4) {
      this.formatBillingAddress(this.currentBooking.bookingJourney[0].collectionLocation);
      this._customerLocationCoord = this.currentBooking.bookingJourney[0].collectionLocation.geoCoord;
    } else if (this.flightDirection === 2 && this.currentBooking.bookingJourney[0].deliveryLocation.type === 4) {
      this.formatBillingAddress(this.currentBooking.bookingJourney[0].deliveryLocation);
    }

    this.milesLoaded = currentAppState.milesAndMoreReducer.miles?.serviceCardNumber ? 'success' : 'idle';

    const state = this.getState(this._appStore);
    if (state.bookingReducer.bookingDetails.promo.length > 0) {
      this.togglePromo = true;
    }
  }

  formatBillingAddress(address) {
    this.billingAddress = {
      country: this.countryCodes.find(item => item.countryName === address.addressCountry || item.countryCodeName === address.addressCountry).countryCodeName,
      city: address.addressTown,
      street: address.addressLine2,
      houseNumberOrName: address.addressLine1,
      stateOrProvince: address.addressCounty,
      postalCode: address.addressPostCode,
      geoCoord: this._customerLocationCoord
    };
    this.billingAddressValid = true;
  }

  getLatestCurrentBooking() {
    const currentAppState: AppState = this.getState(this._appStore);
    // current booking store vars
    this.currentBooking = currentAppState.currentBookingReducer.currentBooking;
    this._bookingCompleteFlag = this.currentBooking.bookingCompletion.bookingComplete;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }


  getCopy() {
    const panelHeader = this._copyService.getCopyBySection(
      this._bookingCarrier,
      window.location.pathname.split('/')[2],
      ['panelHeader', this.flightDirection === 1 ? 'outbound' : 'inbound']
    );
    const termsAndConditionsCopy = this._copyService.getCopyBySection(
      this._bookingCarrier,
      window.location.pathname.split('/')[2],
      ['termsAndConditions']
    );

    const overView = this._copyService.getCopyBySection(
      'OTHER',
      'overview',
      [this.flightDirection === 1 ? 'outbound' : 'inbound']
    );

    this.appCopy = {
      termsAndConditions: termsAndConditionsCopy[0],
      panelHeader: { ...overView[0], ...panelHeader[0] }
    };
    // console.log(overView, panelHeader)
  }

  getAirportCopy() {
    this.appAirportCopy = this._airportCopyService.getAirportsCopy();
  }

  // emitted data/functions from child components
  // phone validation
  handleValidatePhoneNumber(data) {
    this.phoneNumberValid = false;
    this._bookingService.validatePhoneNumber(data);
  }

  resetBottomForm() {
    const state = this.getState(this._appStore);
    const isLogin = state.userReducer.userDetails.userLoggedIn
    this._loginService.logout();
    this.bookerForm.form.reset();
    this.termsForm.form.reset();
    if(!isLogin) {
      this.standardPaymentForm.form.reset();
    }
  }

  handleEmailInputChange() {
    const termsForm = typeof this.termsFormExpresscheckout !== 'undefined';
    if (termsForm && !this.termsFormExpresscheckout.form.valid) {
      this.termsFormExpresscheckout.reset();
    }
  }
  // newsletter checkbox
  customsForInspection(val: any) {
    this._bookingService.updateCustomsForInspection(val.currentTarget.checked);

  }
  sendNewsLetterOptIn(value) {
    this._bookingService.updateNewsletterOptIn(value);
  }
  iUnderstand(val: any) {
    if (val.currentTarget.checked === true) {
      ga('send', 'event', 'Vanilla', 'Pay - Consent', 'Checked');
    }
  }

  iVerify(val: any) {
    if (val.currentTarget.checked === true) {
      this._appStore.dispatch(hasCustomsAgreement({payload: true }));
    } else {
      this._appStore.dispatch(hasCustomsAgreement({payload: false }));
    }
  }
  skywardsCheck(val: any): void {
    this._bookingService.updateEmiratesSkywardsAcknowledgment(val.currentTarget.checked)
  }
  // data checkbox
  sendDataSharingAllowed(value) {
    this._bookingService.updateDataSharingAllowed(value);
  }
  updateSmsMarketingReminder(value) {
    this._bookingService.updateSmsMarketingReminder(value);
  }
  togglePayByInvoice(event) {
    this.payByInvoice = !this.payByInvoice;
  }
  // booker data to addBooking
  sendBookerToRequest(data) {
    this._bookingService.updateBooker(data);
  }
  // send amend data to api
  sendBookerToAmend() {
    if (this.bookingType === 'amend') {
      const amendData = {
        reference: this._bookingJourneyReference,
        flag: 64
      };
      this._bookingService.postAmend(amendData);
    }
  }

  cancelAmend() {
    this._router.navigate(['my-account/bookings/booking-details'],
      { queryParams: { ref: this.currentBooking.bookingReference } });
  }

  deleteSavedCard(value) {

    const modalData: ModalData = {
      type: 'default',
      modalType: 'deleteCard',
      title: this.appCopy.panelHeader['removeCardModalTitle' + this.selectedLanguage], //'Remove card?',
      content: this.appCopy.panelHeader['removeCardModalContent' + this.selectedLanguage], //'Are you sure you want to remove this card?',
      buttonText: this.appCopy.panelHeader['removeCardButton' + this.selectedLanguage], //'Yes, remove my card',
      cancelButtonText: this.appCopy.panelHeader['cancelRemoveCardButton' + this.selectedLanguage], //'No, keep my card',
      cardReference: value,
      userId: this.userDetails.currentUser.userId,
      userToken: this.userDetails.userToken
    };

    this._errorService.handleModal(modalData);

  }

  sendToPayment(data, forceRetry?) {

    let isRetry = false;

    if (data.payment.transactionType === 'Retry' || forceRetry) { isRetry = true; }

    this._bookingService.updateBookingFlagsBooking(true);
    this._bookingService.updatePayment(
      data.payment,
      data.promo,
      data.isCustomerService,
      data.billingAddress,
      this.bookingProduct,
      this.userDetails.userLoggedIn,
      isRetry,
      this.bookingType);

    this._dataStorageService.saveData();

    if (!isRetry) {
      this.sendFBPixelEvent();
    }
  }

  sendToPaymentAmend(data?) {
    const amendStoreItem = this.getState(this._appStore).currentBookingReducer.amendBooking;
    const amendData = {
      reference: this._bookingJourneyReference,
      flag: amendStoreItem.amendBookingFlag
    };

    this._bookingService.updatePaymentForAmends(data.payment, data.promo, data.isCustomerService, data.billingAddress, amendData);
  }

  // amend submit function
  handleBookerAmend() {
    if (this.phoneNumberValid) {
      this.showAmendLoader = true;
      this.paymenttype === 2 ? this.handlePaymentSubmit() : this.handlePaymentOptionSubmit();
    }
  }

  // amend payment submit function
  handlePaymentAmend() {
    const formHasStandardForm = typeof this.standardPaymentForm !== 'undefined';
    const formHasRecurringForm = typeof this.recurringPaymentForm !== 'undefined';

    this._applePayData = this._bookingService.getApplePaymentToken();

    if (formHasStandardForm && !this.standardPaymentForm.form.valid) {
      this._validationService.markFormDirty(this.standardPaymentForm.form);
      return;
    }

    if (formHasStandardForm && this.standardPaymentForm.billingAddressForm) {
      if (this.standardPaymentForm.billingAddressForm.form.valid) {
        const billingForm = this.standardPaymentForm.billingAddressForm.form.value;
        if (!this.validateBillingAddress(billingForm)) {
          return
        }
        this.formatBillingAddress(this.standardPaymentForm.billingAddressForm.locationData);
      } else {
        this.billingAddressValid = false;
        return;
      }
    }

    if (formHasRecurringForm && !this.recurringPaymentForm.form.valid) {
      this._validationService.markFormDirty(this.recurringPaymentForm.form);
      return;
    }

    if (formHasRecurringForm && this.recurringPaymentForm.billingAddressForm) {
      if (this.recurringPaymentForm.billingAddressForm.form.valid) {
        const billingForm = this.recurringPaymentForm.billingAddressForm.form.value;
        if (!this.validateBillingAddress(billingForm)) {
          return;
        }
        this.formatBillingAddress(this.recurringPaymentForm.billingAddressForm.locationData);
      } else {
        this.billingAddressValid = false;
        return;
      }
    }

    // Google Pay Data
    // this._googlePayData = this._bookingService.getGooglePaymentToken();
    // this.oldprice = this._bookingService.getOldPriceService();

    // if (this._paymentMethod === 0) {
    //   if (this.price.totalPrice.majorAmount > 0) {
    //     if (this._googlePayData == '') {
    //       const x = document.getElementById('googlepayValidation');
    //       x.style.display = "block";
    //       return;
    //     }

    //     if(this.price.totalPrice.majorAmount !== this.oldprice.totalPrice.majorAmount) {
    //       const y = document.getElementById('googlepayRefile');
    //       y.style.display = "block";
    //       return;
    //     }

    //   }
    // }

    this.setPaymentType(formHasStandardForm, formHasRecurringForm);

    this.showLoader = true;
    setTimeout(() => {
      this.showLoader = false;
    }, 6500);

  }

  // exponea function

  exponeaEvent(emailid) {
    let email_check: any = true;
    let sms_check: any = false;
    // console.log('email', this.user.userDetails.currentUser.hasMarketingEnrolment);
    // console.log('sms', this.user.userDetails.currentUser.hasSMSMarketingEnrolment);
    // console.log('user in or not', this.user.userDetails.userLoggedIn);

    if (this.user.userDetails.userLoggedIn) {
      const emailCheck = this.user.userDetails.currentUser.hasMarketingEnrolment;
      const emailSms = this.user.userDetails.currentUser.hasSMSMarketingEnrolment;

      if (emailCheck === true) {
        email_check = 'accept'
      } else {
        email_check = 'reject'
      }

      if (emailSms === true) {
        sms_check = 'accept'
      } else {
        sms_check = 'reject'
      }
    } else {
      // const emailCheck = this.bookerForm.form.controls['optOutMarketingEnrolment'].value;
      // need to update this code from model later after confirmation from kosta
      const emailSms = true;
      const emailCheck = this.bookerForm.form.value.hasSmsMarketingEnrolment;

      if (emailCheck === true) {
        email_check = 'accept'
      } else {
        email_check = 'reject'
      }

      if (emailSms === true) {
        sms_check = 'accept'
      } else {
        sms_check = 'reject'
      }

    }


    // const emailid = this.bookerForm.form.controls['bookerEmail'].value;
    exponea.identify({ 'email_id': emailid });

    fetch('https://api.ipify.org?format=json').then(results => results.json()).then(data => {
      const vari = data;
      exponea.track('consent', {
        'email_id': emailid,
        'action': email_check,
        'category': "email",
        'valid_until': 'unlimited',
        'ip': data.ip,
        'message': "Untick this box if you do not wish to be kept informed about special offers, new services and airline partners.",
        'touchpoint': "oldfunel_payment"
      })
        // exponea.track('consent', {
        //   'email_id': emailid,
        //   'action': sms_check,
        //   'category': "sms",
        //   'valid_until': 'unlimited',
        //   'ip': data.ip,
        //   'message': "We’ll send you occasional discounts and personalised travel reminders via SMS. Tick this box to confirm your consent (you can withdraw at any time)",
        //   'touchpoint': "oldfunel_payment"
        // })
    });
  }
  // main submit function
  // gets data from child components
  validateBillingAddress(billingForm) {
    if (billingForm.collectionAddressCountry.trim()
      && billingForm.collectionAddressCounty.trim()
      && billingForm.collectionAddressLine1.trim()
      && billingForm.collectionAddressLine2.trim()
      && billingForm.collectionAddressPostcode.trim()
      && billingForm.collectionAddressTown.trim()) {
      this.billingAddressValid = true;
      return true;
    } else {
      this.billingAddressValid = false;
      return false;
    }
  }


  handlePaymentSubmit() {
    this.setCurrentStoreVars();
    this.handleEmailInputChange();

    const formHasStandardForm = typeof this.standardPaymentForm !== 'undefined';
    const formHasRecurringForm = typeof this.recurringPaymentForm !== 'undefined';

    const termsForm = typeof this.termsForm !== 'undefined';

    this._applePayData = this._bookingService.getApplePaymentToken();

    this.billingAddressValid = true;

    let bookerForm; // for apple pay & card payment
    let standardForm; // for card payment
    let recurringForm;// for card payment
    let billingForm; // for card payment
    let termsFormData; // for apple pay

    if (formHasStandardForm && this.standardPaymentForm.form.valid) {
      standardForm = this.standardPaymentForm.form.value;
    }
    if (formHasRecurringForm && this.recurringPaymentForm.form.valid) {
      recurringForm = this.recurringPaymentForm.form.value;
    }


    // validate booker form and booking contact form
    // pass in form and form data
    // send errors back to ui
    const bookerFormHasError = this._validationService.handleBookerValidation(this.bookerForm.form, this.bookerForm.bookerData);

    if (termsForm && !this.termsForm.form.valid) {
      this._validationService.markFormDirty(this.termsForm.form);
      return;
    }

    if (formHasStandardForm && !this.standardPaymentForm.form.valid) {
      this._validationService.markFormDirty(this.standardPaymentForm.form);
      return;
    }

    if (formHasStandardForm && this.standardPaymentForm.billingAddressForm) {
      if (this.standardPaymentForm.billingAddressForm.form.valid) {
        const billingForm = this.standardPaymentForm.billingAddressForm.form.value;
        if (!this.validateBillingAddress(billingForm)) {
          return
        }
        this.formatBillingAddress(this.standardPaymentForm.billingAddressForm.locationData);
      } else {
        this.billingAddressValid = false;
        return;
      }
    }

    if (formHasRecurringForm && !this.recurringPaymentForm.form.valid) {
      this._validationService.markFormDirty(this.recurringPaymentForm.form);
      return;
    }

    if (formHasRecurringForm && this.recurringPaymentForm.billingAddressForm) {
      if (this.recurringPaymentForm.billingAddressForm.form.valid) {
        const billingForm = this.recurringPaymentForm.billingAddressForm.form.value;
        if (!this.validateBillingAddress(billingForm)) {
          return;
        }
        this.formatBillingAddress(this.recurringPaymentForm.billingAddressForm.locationData);
      } else {
        this.billingAddressValid = false;
        return;
      }
    }

    // Google Pay Data
    // this._googlePayData = this._bookingService.getGooglePaymentToken();
    // this.oldprice = this._bookingService.getOldPriceService();

    // if (this._paymentMethod === 0) {
    //   if (this.price.totalPrice.majorAmount > 0) {
    //     if (this._googlePayData == '') {
    //       const x = document.getElementById('googlepayValidation');
    //       x.style.display = "block";
    //       return;
    //     }

    //     if (this.price.totalPrice.majorAmount !== this.oldprice.totalPrice.majorAmount) {
    //       const y = document.getElementById('googlepayRefile');
    //       y.style.display = "block";
    //       return;
    //     }

    //   }
    // }

    const bookingDetails = this.bookingState.bookingDetails;
    const duration = moment.duration(moment().diff(bookingDetails.autoRefreshTime));
    const params = this._activatedRoute.parent.snapshot.data['bookingProduct'];
    const modalData: ModalData = {
      type: 'default',
      modalType: 'timeSlotExpried',
      title: this.appCopy.panelHeader[ (params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredTitle' : 'abcTimeslotExpiredTitle' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredTitle' : 'ccdTimeslotExpiredTitle') + this.selectedLanguage],
      content: this.appCopy.panelHeader[ (params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredContent' : 'abcTimeslotExpiredContent' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredContent' : 'ccdTimeslotExpiredContent') + this.selectedLanguage],
      buttonText: this.appCopy.panelHeader[ (params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredButton' : 'abcTimeslotExpiredButton' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredButton' : 'ccdTimeslotExpiredButton') + this.selectedLanguage],
      showLoader: false,
    };

    if (this.bookingType !== 'amend') {
      // this time duration should be 30 and 15 before live updates
      if(bookingDetails.isD2dService && duration.asMinutes() >= 30){
        this._errorService.handleModal(modalData);
        return;
      } else if(duration.asMinutes() >= 15) {
        this._errorService.handleModal(modalData);
        return;
      }
    }
    if (!bookerFormHasError) {
      const d2dReducer = this.getState(this._appStore).d2dReducer;
      termsFormData = this.termsForm ? this.termsForm.form.value : '';
      bookerForm = this.bookerForm.form.value;
      if (d2dReducer.addBookingCount === 0 && this.bookingType !== 'amend') {
        this._appStore.dispatch(saveFormData({
          payload: {
            bookerForm: bookerForm,
            standardForm: standardForm,
            recurringForm: recurringForm,
            billingForm: billingForm,
            billingFormData: this.billingAddress,
            termsFormData: termsFormData
          }
        }));
      }
      this.sendBookerToRequest(this.bookerForm.bookerData);

      // if booking type is amend
      // send to api
      if (this.bookingType === 'amend') {
        this.sendBookerToAmend();
      } else {
        // continue to payment...
        this._appLoaderService.showLoader(this.appCopy.panelHeader['bookingRefTitle' + this.selectedLanguage] + ' = ' + this.bookingState.bookingDetails.bookingReference);

        this.checkNewUser();

        this.setPaymentType(formHasStandardForm, formHasRecurringForm);
      }
    } else {
      this.showAmendLoader = false;
    }

    this.exponeaEvent(this.bookerForm.bookerData.emailAddress);

  }

  handlePaymentOptionSubmit() {
    this.setCurrentStoreVars();

    const formHasStandardForm = typeof this.standardPaymentForm !== 'undefined';
    const formHasRecurringForm = typeof this.recurringPaymentForm !== 'undefined';

    const termsForm = typeof this.termsFormExpresscheckout !== 'undefined';

    this._applePayData = this._bookingService.getApplePaymentToken();


    let bookerForm; // for apple pay & card payment
    let standardForm; // for card payment
    let recurringForm;// for card payment
    let billingForm; // for card payment
    let termsFormDataCheckoutExpress; // for apple pay


    // validate booker form and booking contact form
    // pass in form and form data
    // send errors back to ui

    if (termsForm && !this.termsFormExpresscheckout.form.valid) {
      this._validationService.markFormDirty(this.termsFormExpresscheckout.form);
      return;
    }

    const bookingDetails = this.bookingState.bookingDetails;
    const duration = moment.duration(moment().diff(bookingDetails.autoRefreshTime));
    const params = this._activatedRoute.parent.snapshot.data['bookingProduct'];
    const modalData: ModalData = {
      type: 'default',
      modalType: 'timeSlotExpried',
      title: this.appCopy.panelHeader[ (params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredTitle' : 'abcTimeslotExpiredTitle' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredTitle' : 'ccdTimeslotExpiredTitle') + this.selectedLanguage],
      content: this.appCopy.panelHeader[ (params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredContent' : 'abcTimeslotExpiredContent' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredContent' : 'ccdTimeslotExpiredContent') + this.selectedLanguage],
      buttonText: this.appCopy.panelHeader[ (params === 'abc' ? bookingDetails.isD2dService ? 'd2dTimeslotExpiredButton' : 'abcTimeslotExpiredButton' : bookingDetails.isD2dService ? 'd2dTimeslotExpiredButton' : 'ccdTimeslotExpiredButton') + this.selectedLanguage],
      showLoader: false,
    };

    if (this.bookingType !== 'amend') {
      // this time duration should be 30 and 15 before live updates
      if(bookingDetails.isD2dService && duration.asMinutes() >= 30){
        this._errorService.handleModal(modalData);
        return;
      } else if(duration.asMinutes() >= 15) {
        this._errorService.handleModal(modalData);
        return;
      }
    }

      const d2dReducer = this.getState(this._appStore).d2dReducer;
      termsFormDataCheckoutExpress = this.termsFormExpresscheckout ? this.termsFormExpresscheckout.form.value : '';
      bookerForm = this.bookerForm.form.value;
      if (d2dReducer.addBookingCount === 0 && this.bookingType !== 'amend') {
        this._appStore.dispatch(saveFormData({
          payload: {
            bookerForm: bookerForm,
            standardForm: standardForm,
            recurringForm: recurringForm,
            billingForm: billingForm,
            billingFormData: this.billingAddress,
            termsFormData: termsFormDataCheckoutExpress
          }
        }));
      }
      let bookerDataExpressCheckout;
      let countrycode;
      const googlePayData = this._bookingService.getGooglePaymentToken();
      if(this.paymenttype === 0 && googlePayData) {
        // console.log(googlePayData)
        const fullName = googlePayData.shippingAddress.name;
        const nameParts = fullName.split(" ");
        const firstName = nameParts[0];
        const lastName = nameParts.slice(1).join(" ");
        const parsedPhoneNumber = this._loginService.parsePhoneNumber(googlePayData.shippingAddress.phoneNumber);
        exponea.identify({ 'email_id': googlePayData.email });
        // console.log(`exponea: identify user with google payment token`);
        COUNTRY_CODES.all.find((item) => {
          if(item.countryCodeName === googlePayData.shippingAddress.countryCode) {
            // console.log('item.countryName',item.countryName);
            countrycode = item.countryCode
          }
        });
        bookerDataExpressCheckout = {
          countryCode: parsedPhoneNumber.countryCode ? parsedPhoneNumber.countryCode : countrycode,
          emailAddress: googlePayData.email,
          firstName: firstName,
          lastName: lastName,
          phoneNumber: parsedPhoneNumber.phone
        }
      }
      const applePayData = this._bookingService.getApplePaymentToken();
      if(this.paymenttype === 1 && applePayData) {
        // console.log('data send to booker before add booking api', applePayData)
        const firstName = applePayData.shippingContact.familyName;
        const lastName = applePayData.shippingContact.givenName;
        const parsedPhoneNumber = this._loginService.parsePhoneNumber(applePayData.shippingContact.phoneNumber);
        exponea.identify({ 'email_id': applePayData.email });
        // console.log(`exponea: identify user with apple payment token`);
        COUNTRY_CODES.all.find((item) => {
          if(item.countryName === applePayData.shippingContact.country) {
            // console.log('item.countryName',item.countryName);
            countrycode = item.countryCode
          }
        });
        // console.log(parsedPhoneNumber.phone, 'countryCode', countrycode);
        bookerDataExpressCheckout = {
          countryCode: parsedPhoneNumber.countryCode ? parsedPhoneNumber.countryCode : countrycode,
          emailAddress: applePayData.shippingContact.emailAddress,
          firstName: firstName,
          lastName: lastName,
          phoneNumber: parsedPhoneNumber.phone
        }
      }
      // console.log('bookerDataExpressCheckout', bookerDataExpressCheckout);
      if (applePayData || googlePayData) {
        this.sendBookerToRequest(bookerDataExpressCheckout);
      } else {
        this.sendBookerToRequest(this.bookerForm.bookerData);
      };




      // if booking type is amend
      // send to api
      if (this.bookingType === 'amend') {
        this.sendBookerToAmend();
      } else {
        // continue to payment...
        this._appLoaderService.showLoader(this.appCopy.panelHeader['bookingRefTitle' + this.selectedLanguage] + ' = ' + this.bookingState.bookingDetails.bookingReference);

        // this.sendUserEmail();

        this.setPaymentType(formHasStandardForm, formHasRecurringForm);
      }

      // no need to send exponea event ExpressCheckout case

    // this.exponeaEvent(bookerDataExpressCheckout.emailAddress);

  }

  useSavedCard() {
    // let thisCard = null;
    this._encryptedData = '';
    this._savedCardDetails = this.userCards.find(x => x.recurringDetailReference === this._recurringReference);
    this._maskedNumber = this._savedCardDetails.number;
    const currentBooking = this.getState(this._appStore).currentBookingReducer.currentBooking;
    let collectionCity = '';
    if (currentBooking.bookingJourney) {
      collectionCity = currentBooking.bookingJourney[0].collectionLocation.addressTown;
    }

    if (this._useSavedCard) {
      if (this._savedCardDetails.hasBillingAddress) {
        const savedAddress = JSON.parse(JSON.stringify(this._savedCardDetails.billingAddress));
        if (!this._savedCardDetails.billingAddress.addressTown) {
          savedAddress.addressTown = collectionCity;
        }
        this.formatBillingAddress(savedAddress);
      } else {
        this.billingAddress = null;
        this.billingAddressValid = true;
      }
      this._appStore.dispatch(cardType({ payload: this._savedCardDetails.cardType }));
      this._appStore.dispatch(paymentWithSavedCard({payload: true }));
    }
    this.callApi();
  }

  private setPaymentType(formHasStandardForm, formHasRecurringForm) {

    // check to see if user has a selected card item
    // and if saved card is true
    // this comes from the recurring payment form
    if (formHasRecurringForm && this.paymenttype !== 1 && this.paymenttype !== 0) {
      this._saveCard = this.recurringPaymentForm.form.value.saveCard === '' ? false : this.recurringPaymentForm.form.value.saveCard;
      this._useSavedCard = typeof this.recurringPaymentForm.selectedCardItem !== 'undefined' && this.recurringPaymentForm.selectedCardItem !== '' && this.recurringPaymentForm.selectedCardItem !== 'newCard';
    } else {
      this._useSavedCard = false;
    }

    // if standard form check to see if save card is true
    if (formHasStandardForm) {
      this._saveCard = this.standardPaymentForm.form.value.saveCard === '' ? false : this.standardPaymentForm.form.value.saveCard;
    }

    // if user is paying by invoice or CS overrides payment
    // skip card encryption
    if ((this.eligibleForInvoice && this.payByInvoice) || (this.bookingType === 'amend' && this.overridePayment) || this.paymenttype === 1 || this.paymenttype === 0) { // for apple payments
      this.callApi();
    } else if (this._useSavedCard) {
      this._recurringReference = this.recurringPaymentForm.selectedCardItem;
      this.useSavedCard();
      // if(this._paymentMethod !== 0) {
      // this.useSavedCard();
      // }
    } else {
      let data = null;
      if (formHasStandardForm) {
        data = this.standardPaymentForm.form.value;
      } else {
        data = this.recurringPaymentForm.form.value;
      }

      const obscuredCardNumber = data.ccnumber ? data.ccnumber[0] : 0;
      let varcardType = ''
      if (obscuredCardNumber) {
        varcardType = cardTypes[obscuredCardNumber];
      }
      this._appStore.dispatch(cardType({ payload: varcardType }));
      this._appStore.dispatch(paymentWithSavedCard({payload: false }));
      this.encryptMyData(data);
    }
  }

  private sendUserEmail() {
    // console.log('payment method',this.paymenttype);
    if(this.paymenttype === 1) {
      const data = this._bookingService.getApplePaymentToken();
      // console.log('apple pay data token',data);
      const newUser = {
        emailAddress: data.shippingContact.emailAddress,
        };

      this._appStore.dispatch(UPDATE_NEW_USER({ newUser: newUser }));
    }
    if(this.paymenttype === 0) {
      const data = this._bookingService.getGooglePaymentToken();
      // console.log('google pay data token',data);
      const newUser = {
        emailAddress: data.email
        };
        this._appStore.dispatch(UPDATE_NEW_USER({ newUser: newUser }));
    }


  }

  private checkNewUser() {
    // if user has set a password, save it and login
    if (typeof this.bookerForm.form.controls['setPassword'] !== 'undefined' && this.bookerForm.form.controls['setPassword'].value !== '') {

      const newUser = {
        emailAddress: this.bookerForm.form.controls['bookerEmail'].value,
        password: btoa(this.bookerForm.form.controls['setPassword'].value)
      };

      this._appStore.dispatch(UPDATE_NEW_USER({ newUser: newUser }));
      this._appStore.dispatch(updateCustomerHasMarketingEnrolment({payload: true }));
    }
  }

  // encrypt card data
  private encryptMyData(value) {
    this._dt = new Date();

    if (this.price.totalPrice.majorAmount !== 0 && this.paymenttype !== 0 && this.paymenttype !== 1 && this.bookingAmendType !== 'refund') {
      this._cardData = {
        number: value.ccnumber.toString().replace(/\s+/g, ''),
        cvc: value.CardSecurityCode.toString(),
        holderName: value.nameoncard.toString(),
        expiryMonth: value.ccexpmonth.toString(),
        expiryYear: '20' + value.ccexpyear.toString(),
        generationtime: this._dt
      };
    } else {
      this._cardData = {
        number: '',
        cvc: '',
        holderName: '',
        expiryMonth: '',
        expiryYear: '',
        generationtime: ''
      };
    }

    const _cseInstance = adyen.encrypt.createEncryption(this._key, this._options);
    this._encryptedData = _cseInstance.encrypt(this._cardData);
    this._maskedNumber = this.price.totalPrice.majorAmount === 0 ? '' : this._cardData.number.replace(/.(?=.{4,}$)/g, '*');
    this.callApi();
  }

  // check for errors
  // then form request to send to booking service
  private callApi() {

    const requestData = {
      payment: null,
      promo: null,
      isCustomerService: false,
      billingAddress: this.billingAddress
    };

    // skip 3DS check if admin booking/amend
    if (this.isCustomerSupport) {
      requestData.billingAddress = null;
    }

    const bookingMinorPrice = parseInt(this.price.totalPrice.minorAmount, 10);
    const fullBookingPrice = parseInt(this.price.pricingResponse[0].pricingBreakdown.totalPriceMinor, 10);
    if (this.paymenttype === 0 || this.paymenttype === 1) { // for apple pay & google pay
      this._encryptedData = 'false'
    }
    // // console.log('encryptedData', !this._encryptedData, 'price', this.price.totalPrice.majorAmount !== 0 , 'save card', !this._useSavedCard, 'invoice', !this.payByInvoice, 'overridepayment', !this.overridePayment);
    // if adyen returns false
    // show invalid card error toast message
    if (!this._encryptedData && this.price.totalPrice.majorAmount !== 0 && !this._useSavedCard && !this.payByInvoice && !this.overridePayment && this.bookingAmendType !== 'refund') {
      // return;
      this.disableBook = false;
      this._appLoaderService.hideLoader();
      const error = {
        text: "Invalid card number. Please try again or contact <a href='mailto:support@portr.com'>support@portr.com</a>",
        sticky: true
      };
      this._errorService.handleCustomError(error);
      return;
    }


    // Google Pay Data
    this._googlePayData = this._bookingService.getGooglePaymentToken();

    // Apple Pay Data
    this._applePayData = this._bookingService.getApplePaymentToken();
    this._applePayToken = ''; // reset this token

    if (this.paymenttype === 0) {
      if (this._googlePayData != '') {
        // Google Pay Token
        // this._googlePayToken = this._googlePayData.tokenizationData.token;
        this._googlePayToken = this._googlePayData.paymentMethodData.tokenizationData.token;
        // Google Pay Card Number
        this._googlePayMaskNumber = this._googlePayData.paymentMethodData.info.cardDetails;
        // businessTransactionType
        this._transactionType = 'New';
        this._businessTransactionType = 'NewBusiness';
      }

      this._useSavedCard = false;
    }  else if (this.paymenttype === 1) {
      if (this._applePayData != null) {
        // Apple Pay Token
        this._applePayToken = JSON.stringify(this._applePayData.token.paymentData);
        // businessTransactionType
        this._transactionType = 'New';
        this._businessTransactionType = 'NewBusiness';
      }

      this._useSavedCard = false;
    } else {
      this._googlePayToken = '';
      this._googlePayMaskNumber = this._maskedNumber;
      // businessTransactionType
      this._transactionType = 'New';
      this._businessTransactionType = 'NewBusiness';
    }

    const currencyCode = this.getState(this._appStore).timeslotReducer.currency.code;
    const paymentRequest: PaymentRequest = {
      bookingReference: this.bookingState.bookingDetails.bookingReference,

      obscuredCardNumber: this._googlePayMaskNumber,
      googlePayToken: this._googlePayToken,
      applePayToken : this._applePayToken,
      encodedCardInformation: this._encryptedData,
      amount: bookingMinorPrice,
      fullAmount: fullBookingPrice,
      quoteId: this.price.quoteId,
      transactionType: this._transactionType,
      businessTransactionType: this._businessTransactionType,
      currency: currencyCode,

      isPaidByInvoice: this.payByInvoice,
      saveCard: this._saveCard,

      hasBillingAddress: this._useSavedCard ? this._savedCardDetails.hasBillingAddress : false,
      recurringReference: this._recurringReference === '' ? null : this._recurringReference,
    }
    ;

    let promoRequest = {};
    let promo = {
      promotType: this.price.promotionRewardType ?? 0,
      promoAmount: this.price.promotionRewardAmount
    };

    this._appStore.dispatch(promoDetails({ payload: promo }));

    if (this._promoActive) {
      promoRequest = {
        promoCode: this.price.promoCodesApplied[0],
        promoDiscountAmount: this._promoDiscount
      };
      ga('send', 'event', 'Promo Code Used', this.price.promoCodesApplied[0]);
    } else {
      promoRequest = {};
    }

    if (this.bookingType !== 'amend') {
      if (typeof this.bookerForm.form.controls['hasSmsMarketingEnrolment'] !== 'undefined') {
        const hasSmsMarketingEnrolment = this.bookerForm.form.controls['hasSmsMarketingEnrolment'].value;
        if(this.paymenttype !== 2) {
          this.sendNewsLetterOptIn(false);
          this.updateSmsMarketingReminder(false);
        } else {
          this.sendNewsLetterOptIn(hasSmsMarketingEnrolment);
          this.updateSmsMarketingReminder(hasSmsMarketingEnrolment);
        }

      } else {
        this.sendNewsLetterOptIn(true);
        this.updateSmsMarketingReminder(true);
      }
    }

    this.sendDataSharingAllowed(true);

    this.getLatestCurrentBooking();

    const csMoto = this.getState(this._appStore).flightFinderReducer.csMotoFromUrl;
    // if payment or booking amend
    // set correct transaction type
    // call amend booking
    if ((this.bookingState.bookingDetails.bookingAmendType === 'payment' || this.bookingState.bookingDetails.bookingAmendType === 'refund') && this.bookingType === 'amend') {

      if (this.overridePayment) {
        paymentRequest.transactionType = 'OverridePayment';
        paymentRequest.amount = 0;
      } else {
        paymentRequest.transactionType = 'Amendment';
        paymentRequest.amount = this._priceHistoryMinor;
        paymentRequest.googlePayToken = this._googlePayToken;
      }
      paymentRequest.businessTransactionType = this.bookingState.bookingDetails.bookingAmendType === 'payment' ? 'Amendment' : 'Refund';
      paymentRequest.fullAmount = this._priceHistoryMinor;
      requestData.payment = paymentRequest;
      requestData.promo = promoRequest;
      requestData.isCustomerService = csMoto;

      this.disableBook = true;
      if (this.getState(this._appStore).bookingReducer.bookingDetails.bookingAmendPaymentFailed) {
        this.sendToPayment(requestData, true);
      } else {
        this.sendToPaymentAmend(requestData);
      }

    } else {
      // if adding payment to completed booking
      // DON'T call addBooking..
      // call makePayment
      if (this._bookingCompleteFlag) {
        // booking complete - payment failed
        paymentRequest.transactionType = 'Retry';
        requestData.payment = paymentRequest;
        requestData.promo = promoRequest;
        requestData.isCustomerService = csMoto;
        this.sendToPayment(requestData);
      } else {
        // new payment request
        paymentRequest.transactionType = this._transactionType;
        requestData.payment = paymentRequest;
        requestData.promo = promoRequest;
        requestData.isCustomerService = csMoto;
        this.sendToPayment(requestData);
      }

      this.disableBook = true;

    }

  }

  // conversion tracking - external
  sendFBPixelEvent() {
    const flightData = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
    const direction = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightDirection === 1 ? 'Out' : 'In';
    const price = this.price.totalPrice.majorAmount;
    const bookingProduct = this.bookingProduct.toUpperCase() + (this.bookingProduct === 'ccd' ? direction : '');
    const departureAirport = flightData.departureAirport.airportCode;
    const arrivalAirport = flightData.arrivalAirport.airportCode;
    const airlineCode = flightData.operatingAirlineCode;
    const departureDate = moment(flightData.departureDateTimeDetails.scheduledDate).format('DD/MM/YYYY');
    const bookingRef = this.bookingState.bookingDetails.bookingReference;
    const bags = this.bookingState.bookingDetails.virtualBagCount;

    fbq('track', 'Purchase', {
      currency: 'GBP',
      value: price,
      content_category: bookingProduct,
      content_type: 'product',
      content_ids: [
        departureAirport,
        airlineCode,
        departureDate
      ],
      contents: [{
        id: bookingRef,
        quantity: bags
      }]
    });
  }


  handleThreeDSIframeEvent(e) {
    if ((e.origin === this.threeDS2Data.originURL || e.origin === this.threeDs1Data.notificationUrl) && e.data.resultCode) {
      if (e.data.resultCode === 'ChallengeShopper') {
        // remove identifyShopper iframe if it exists
        const iframe = document.getElementsByClassName('threeDSMethodIframeClass')[0];

        if (iframe) {
          document.getElementById('threedsContainer').removeChild(iframe);
        }

        // do ChallengeShopper
        const data = {
          serverTransID: e.data.challengeThreeDSServerTransID,
          acsTransID: e.data.acsTransID,
          messageVersion: e.data.messageVersion,
          acsURL: e.data.acsURL,
          originURL: this.threeDS2Data.originURL
        };

        this._bookingService.initiateChallengeShopper(data);
        this._sharedService.challengeShopperSubject$.next(true);
      } else if (e.data.resultCode === 'Authorised') {

        if (this.bookingType === 'amend') {
          this._bookingService.handleAmendSuccess();
        } else {
          this._bookingService.handleBookingSuccess();
        }

      } else if (e.data.resultCode === 'Refused') {
        this.showChallengeShopper = false;
        this._threedsContainer.removeChild(this._threedsIframe);
        this._sharedService.challengeShopperSubject$.next(false);

        const error = {
          text: 'Payment was refused. Please check your payment details and try again.',
          sticky: false
        };
        this._errorService.handleCustomError(error);
      }
    }

  }

  handleApplePay(e) {
    if (this.bookingType === 'new') {
      this.setCurrentStoreVars();
    }

    const termsForm = typeof this.termsFormExpresscheckout !== 'undefined';

    this.billingAddressValid = true;

    // const bookerFormHasError = this._validationService.handleBookerValidation(this.bookerForm.form, this.bookerForm.bookerData);

    if (termsForm && !this.termsFormExpresscheckout.form.valid) {
      this._validationService.markFormDirty(this.termsFormExpresscheckout.form);
      return;
    }

      // initialize apple payment
      // console.log(`initializing apple payment`)

      this.applePayForm.onApplePay();


  }

  handleApplePayComplete(){
    this.recievePaymentType(1);
    if (this.bookingType === 'amend') {
      this.handlePaymentAmend();
    } else {
      this.handlePaymentOptionSubmit();
      // this.handlePaymentSubmit();
      // console.log('handle apple pay submint to call add booking');
    }

  }

  goPanelBack() {
    this._eventsService.goToPanel('prev');
  }

  milesLoginRedirect() {
    let lastStatus = this.milesLoaded;
    this.milesLoaded = 'loading';
    const languageCode = this.getState(this._appStore).copyReducer.languageCode;
    this._dataStorageService.saveDataPromise()
    .then(res => {
      this.milesLoaded = lastStatus;
      if (res) {
          const anchorTag = document.createElement('a');
          const milesLink = `${this.milesLoginUrl}&lang=${languageCode}&redirect_uri=${this.callbackURL}`
          anchorTag.setAttribute('href', milesLink);
          anchorTag.hidden = true;
          document.body.appendChild(anchorTag);
          anchorTag.click();
        } else {
          this._errorService.handleCustomError({
            text: 'Miles login failed, please try again',
            sticky: false
          })
        }
      });
  }

  scrollToPromoField() {
    this.togglePromo = true;
    new Promise((resolve) => {
      setTimeout(() => {
        resolve('');
      }, 10);
    }).then(() => {
      const promoField = document.getElementById('PromoCode');
      promoField.scrollIntoView({ behavior: 'smooth' });
    });
  }

  autoBookingSubmit() {
    const state = this.getState(this._appStore);
    const milesReducer = state.milesAndMoreReducer;
    let timer;
    if (state.bookingReducer.bookingDetails.isD2dService && state.d2dReducer.addBookingCount === 1) {
      // remove promo if it was applied on timeslot screen but removed in other booking
      if (state.d2dReducer.promoCode.length === 0) {
        this._appStore.dispatch(removePromo({ payload: [] }));
      }
      this._appStore.dispatch(refreshBookingObject({payload: null}));
      timer = setTimeout(async () => {
        if (milesReducer.milesRedeemed && milesReducer.milesVerified?.status === 'AUTHORISED') {
          try {
            const price: any = await this._pricingService.getPricePromise();
            let milesDiscount = 0;
            if (price.pricingResponse && price.pricingResponse[0]) {
              milesDiscount = price.pricingResponse[0].pricingBreakdown.milesDiscountMinor
            }
            const state = this.getState(this._appStore);
            const request = {
              bookingReference: state.bookingReducer.bookingDetails.bookingReference,
              transactionId: state.milesAndMoreReducer.payByMilesResponse.transactionId,
              transactionStatus: 'AUTHORISED',
              milesDiscount: milesDiscount
            };
            const res = await this._milesAndMoreService.amendMcheckoutStatusPromise(request);
            if (res === 'error') {
              await this._pricingService.getPricePromise();
            }
            this.paymenttype === 2 ? this.handlePaymentSubmit() : this.handlePaymentOptionSubmit();
          } catch (e) {
             // console.log(e);
          }
        } else {
          if (this.showLoader) {
            clearTimeout(timer);
            this.autoBookingSubmit();
            return;
          }
          this.paymenttype === 2 ? this.handlePaymentSubmit() : this.handlePaymentOptionSubmit();
        }
      }, 2500);
    }
  }

  ngAfterViewInit(): void {
    const d2dReducer= this.getState(this._appStore).d2dReducer;
    // need to get new quote id in case of d2d primary booking
    this.isD2dService = this.getState(this._appStore).bookingReducer.bookingDetails.isD2dService;
    if (this.isD2dService && d2dReducer.addBookingCount === 1) {
      this._pricingService.getPrice();
      // set payment type standard/recurring or Apple pay
      this.paymenttype = d2dReducer.paymentType;
    }
    // console.log('setting payment type from reducer for d2d booking', d2dReducer.paymentType)


    this.autoBookingSubmit();
  }

  ngOnDestroy() {
    if (this._bookingInitSubscription) { this._bookingInitSubscription.unsubscribe(); }
    if (this._userSubscription) { this._userSubscription.unsubscribe(); }
    if (this._priceSubscription) { this._priceSubscription.unsubscribe(); }
    if (this._bookingStateSubscription) { this._bookingStateSubscription.unsubscribe(); }
    if (this._validatePhoneNumberSubscription) { this._validatePhoneNumberSubscription.unsubscribe(); }
    if (this._cardDeletedSubscription) { this._cardDeletedSubscription.unsubscribe(); }
    if (this._updatedUserSubscription) { this._updatedUserSubscription.unsubscribe(); }
    if (this._userLoggedInSubscription) { this._userLoggedInSubscription.unsubscribe(); }
    if (this._userLoggedOutSubscription) { this._userLoggedOutSubscription.unsubscribe(); }
    if (this._loaderSubscription) { this._loaderSubscription.unsubscribe(); }
    if (this._cardDeletedRequestSentSubscription) { this._cardDeletedRequestSentSubscription.unsubscribe(); }
    if (this._stateSubscription) { this._stateSubscription.unsubscribe(); }
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    if (this._amendBookingCallSub) { this._amendBookingCallSub.unsubscribe(); }
    if (this._d2dBookingSubscription) { this._d2dBookingSubscription.unsubscribe(); }
    if (this._upsellBookingSubscription) { this._upsellBookingSubscription.unsubscribe(); }
    if (this._applePaymentSubmitSubscription) { this._applePaymentSubmitSubscription.unsubscribe(); }
    if (this._milesStateSubscription$) { this._milesStateSubscription$.unsubscribe(); }
    if (this._priceStatusSubscription$) { this._priceStatusSubscription$.unsubscribe(); }
    if (this._milesSubscription) { this._milesSubscription.unsubscribe(); }
    if (this._flybackReducerSubscription) { this._flybackReducerSubscription.unsubscribe(); }
    if (isPlatformBrowser(this.platformId)) {
      this._externalScriptsService.removeScript("apple-pay-js");
    }
  }

}
